import React from "react";
import { Toast, Button } from "antd-mobile";
import { post } from "../../utils/request";
import { href, viewPort } from "../../utils/util";

import api from "./api";
import { wxfx } from "../../utils/wxfx.js";

import "./index.less";
let timer;
class yysChargingOperatorShare extends React.Component {
    constructor(...args) {
        super(...args);
        this.phoneRef = null;
        this.codeRef = null;
        this.imgCodeRef = null;
        this.state = {
            urlOps: {},
            modalType: false,
            selectType: false,
            vCode: false,
            second: 60,
            phoneNumber: "",
            imageCode: "",
            messageCode: "",
            imgUrl: "",
            agreementUrl: "",
            serviceAgreenmentType: false,
            recordCode: "",
            province: "",
            city: "",
        };
    }

    // #/yysChargingOperatorShare?name=xxxx&inviteCode=xxx
    componentDidMount() {

        var obj = "",
            obj1 = "",
            ops = {};
        if (window.location.hash.indexOf("?") > -1) {
            obj = decodeURIComponent(window.location.hash).split("?")[1];
            obj1 = obj.split("&");
            for (var i = 0; i < obj1.length; i++) {
                ops[obj1[i].split("=")[0]] =
                    obj1[i].split("=")[1] === "undefined"
                        ? ""
                        : obj1[i].split("=")[1];
            }

            this.setState(
                {
                    urlOps: ops,
                },
                () => {
                    this.fx();
                }
            );
        }
    }

    componentWillUnmount() {
        clearInterval(timer);
    }

    iosFocusFix(e, inputEl) {
        const vp = viewPort();
        if (!vp.ios && !vp.iPhone && !vp.iPad) return;
        e.stopPropagation();
        inputEl.focus();
        inputEl.setSelectionRange(inputEl.value.length, inputEl.value.length);
    }

    fx() {
        wxfx({
            title: "注册远程慧联app充电",
            imgUrl: "https://static.hellogil.com/staticResource/payment/charge_share.png",
            desc: `享受遍布全国超50万充电桩服务`,
            url: `${window.location.href}`,
        });
    }

    // 获取图片验证码
    getImgCode() {
        const { urlOps, phoneNumber } = this.state;
        this.setState(
            {
                modalImgCodeType: true,
            },
            () => {
                post({
                    url: api.imageCode,
                    data: {
                        phoneNumber: phoneNumber,
                        businessType: "LOG_IN",
                    },
                }).then(
                    (res) => {
                        if (res.result === "success") {
                            this.setState({
                                imgUrl: "data:image/jpg;base64," + res.data,
                            });
                        } else {
                            Toast.info(res.msg, 1);
                        }
                    },
                    (res) => {
                        Toast.info("图片验证码获取失败", 1);
                    }
                );
            }
        );
    }

    // 获取验证码
    getMessageCode() {
        clearInterval(timer);
        const { urlOps, phoneNumber, imageCode } = this.state;
        let _this = this;
        post({
            url: api.sendMessageCode,
            data: {
                phoneNumber: phoneNumber,
                audio: 0,
                imageCode: imageCode,
                businessType: "LOG_IN",
            },
        }).then(
            (res) => {
                if (res.result === "success") {
                    _this.setState(
                        {
                            second: 59,
                            recordCode: res.data,
                            modalImgCodeType: false,
                            vCode: true,
                        },
                        () => {
                            let { second } = _this.state;
                            timer = setInterval(function () {
                                if (second < 0) {
                                    clearInterval(timer);
                                    _this.setState({
                                        vCode: false,
                                        second: 60,
                                    });
                                } else {
                                    _this.setState({
                                        second: second--,
                                    });
                                }
                            }, 1000);
                        }
                    );
                } else {
                    clearInterval(timer);
                    Toast.info(res.msg, 1);
                }
            },
            (res) => {
                clearInterval(timer);
                Toast.info(res.msg, 1);
            }
        );
    }

    // 注册
    register() {
        const { urlOps, phoneNumber, messageCode, recordCode, province, city } =
            this.state;
        const baseUrl = `/yysChargingOperatorDownload?name=${urlOps.name}&inviteCode=${urlOps.inviteCode}`;

        post({
            url: api.chargeCarrierInviteRegister,
            data: {
                inviteCode: urlOps.inviteCode,
                phoneNumber,
                messageCode,
                recordCode,
            },
        }).then(
            (res) => {
                if (res.result === "success") {
                    if (res.data && res.data.isWarning === 1) {
                        href(
                            `${baseUrl}&status=fail&reason=${encodeURIComponent(
                                res.data.warningMsg || ""
                            )}`
                        );
                    } else {
                        href(`${baseUrl}&status=success`);
                    }
                } else {
                    Toast.info(res.msg, 1);
                }
            },
            (res) => {
                Toast.info(res.msg || "邀请失败", 1);
            }
        );
        // this.viewPort();
    }
    // viewPort =  () => {
    //     let device_type = navigator.userAgent.toLowerCase();
    //     console.log(device_type);
    // }

    render() {
        const {
            modalImgCodeType,
            selectType,
            vCode,
            second,
            phoneNumber,
            imgUrl,
            imageCode,
            messageCode,
            urlOps,
            serviceAgreenmentType,
            agreementUrl,
            recordCode,
        } = this.state;
        // console.log(urlOps)
        return (
            <div className="yysChargingOperatorShareBox">
                <p className="source">{urlOps.name || ""}运营商有限公司邀请您使用</p>
                <div className="registerBox">
                    <div>
                        <div className="inputBox">
                            <div>
                                <input
                                    ref={el => { this.phoneRef = el; }}
                                    type="text"
                                    placeholder="请输入手机号码"
                                    onTouchStart={(e) => this.iosFocusFix(e, this.phoneRef)}
                                    onChange={(e) => {
                                        this.setState({ phoneNumber: e.target.value });
                                    }}
                                />
                            </div>
                            <div>
                                <input
                                    ref={el => { this.codeRef = el; }}
                                    type="text"
                                    placeholder="请输入验证码"
                                    onTouchStart={(e) => this.iosFocusFix(e, this.codeRef)}
                                    onChange={(e) => {
                                        this.setState({ messageCode: e.target.value });
                                    }}
                                />
                                {vCode ? (
                                    <span>{second}秒后重新获取</span>
                                ) : (
                                    <a
                                        onClick={() => {
                                            if (phoneNumber.length !== 11) {
                                                Toast.info("请填写正确的手机号码", 1);
                                                return;
                                            }
                                            this.getImgCode();
                                        }}
                                    >
                                        获取验证码
                                    </a>
                                )}
                            </div>
                            {recordCode ? (
                                <span>
                                    请输入接收到的验证码（编号{recordCode}）
                                </span>
                            ) : (
                                ""
                            )}
                        </div>
                        <div
                            className="reward_3_row"
                            onClick={() => {
                                if (phoneNumber.length !== 11) {
                                    Toast.info("请填写正确的手机号码", 1);
                                    return;
                                }
                                if (messageCode.length === 0) {
                                    Toast.info("请填写验证码", 1);
                                    return;
                                }
                                if (!selectType) {
                                    Toast.info(
                                        "请同意并勾选《用户协议》《隐私政策》",
                                        1
                                    );
                                    return;
                                }
                                this.register();
                            }}
                        >
                            接受邀请
                        </div>
                    </div>
                    <div className="isAgreementBox">
                        <div
                            className={"radio " + (selectType ? "active" : "")}
                            onClick={() => {
                                this.setState({
                                    selectType: !selectType,
                                });
                            }}
                        >
                            <i></i>
                            <span>我已阅读并同意</span>
                        </div>
                        <div>
                            <a
                                onClick={() => {
                                    this.setState({
                                        serviceAgreenmentType: true,
                                        agreementUrl: `${window.location.origin}/h5Static/#/ServiceAgreenment`,
                                    });
                                }}
                            >
                                《用户协议》
                            </a>
                            <a
                                onClick={() => {
                                    this.setState({
                                        serviceAgreenmentType: true,
                                        agreementUrl: `${window.location.origin}/h5Static/#/PrivacyAgreement`,
                                    });
                                }}
                            >
                                《隐私政策》
                            </a>
                        </div>
                    </div>
                </div>
                <div>
                    <h2>规则说明</h2>
                    <div className="ruleDesc" style={{ lineHeight: "1.5" }}>
                        当您绑定充电伙伴后，您的充电金额将通过伙伴进行充值，并使用伙伴卡进行充电，享受伙伴卡专属优惠。对应充电订单属于慧联非自营充电订单，不支持慧联开票，请联系伙伴进行开票。
                        {/* 1、活动时间：12月1日~12月31日（2000张无门槛充电券发完即止）；<br/>
                    2、活动规则：<br/>
                    ①邀请人在远程慧联app首页点击【邀请有奖】分享给好友，被邀请人注册后即可获得一张5元无门槛充电券，邀请人在被邀请人充值任意一笔充电费后即可获得一张5元无门槛充电券，充电券有效期30天；用户可在“我的”内查看。<br/>
                    ②活动结束时邀请数排名前三（若拉新数相同以谁先拉到该数量的时间排名）的用户瓜分1000元充电大礼包：第一名500元充电券，第二名300元充电券，第三名200元充电券，充电券都是20元面额，有效期一年。（每次充电只能使用一张，充电券只能本账号使用）。 */}
                    </div>
                </div>
                {modalImgCodeType ? (
                    <div className="modalImgCodeBox">
                        <div>
                            <h3>图形验证</h3>
                            <div className="inputBox">
                                <input
                                    ref={el => { this.imgCodeRef = el; }}
                                    type="text"
                                    placeholder="图形验证码"
                                    onTouchStart={(e) => this.iosFocusFix(e, this.imgCodeRef)}
                                    onChange={(e) => {
                                        this.setState({
                                            imageCode: e.target.value,
                                        });
                                    }}
                                />
                                <img
                                    src={imgUrl}
                                    onClick={() => {
                                        this.getImgCode();
                                    }}
                                />
                            </div>
                            <div className="btnBox">
                                <a
                                    onClick={() => {
                                        this.setState({
                                            modalImgCodeType: false,
                                            imageCode: "",
                                        });
                                    }}
                                >
                                    取消
                                </a>
                                <a
                                    onClick={() => {
                                        if (imageCode.length === 0) {
                                            Toast.info("请填写图形验证码", 1);
                                            return;
                                        }
                                        this.getMessageCode();
                                    }}
                                >
                                    确定
                                </a>
                            </div>
                        </div>
                    </div>
                ) : (
                    ""
                )}
                {serviceAgreenmentType ? (
                    <div className="serviceAgreenmentBox">
                        <div>
                            <div className="iframe">
                                <iframe src={agreementUrl}></iframe>
                            </div>
                            <Button
                                type="primary"
                                onClick={() => {
                                    this.setState({
                                        serviceAgreenmentType: false,
                                    });
                                }}
                            >
                                确认
                            </Button>
                        </div>
                    </div>
                ) : (
                    ""
                )}
            </div>
        );
    }
}

export default yysChargingOperatorShare;



// WEBPACK FOOTER //
// ./src/yysChargingOperator/share/index.js